import React from "react";
import { Users } from "lucide-react";

export default function CaregiverCard({ profile }) {
  return (
    <section
      data-testid="caregiver-card"
      className="bg-white border border-[#E5E2DC] rounded-2xl p-6 sm:p-8 print:break-inside-avoid print:break-before-page"
    >
      <div className="text-[10px] tracking-[0.2em] uppercase font-semibold text-[#2B5339] mb-2 inline-flex items-center gap-1.5">
        <Users size={11} /> Caregiver copy · share with family or aide
      </div>
      <h3 className="text-xl font-medium text-[#1C2B23]">{profile.name}</h3>
      <p className="text-xs text-[#5C6B62] mt-1">
        Prepared {new Date().toLocaleDateString()}
      </p>

      <div className="mt-5 divide-y divide-[#F0EFEA] border border-[#E5E2DC] rounded-xl overflow-hidden">
        {profile.meds.map((m) => (
          <div key={m.id} className="p-4 bg-white">
            <div className="flex items-start justify-between gap-3 flex-wrap">
              <div className="flex-1 min-w-[220px]">
                <div className="text-lg font-semibold text-[#1C2B23]">
                  {m.generic_name}
                  {m.brand_name && (
                    <span className="ml-1 text-sm text-[#5C6B62] font-normal">
                      ({m.brand_name})
                    </span>
                  )}
                </div>
                <div className="text-[#2B5339] font-semibold">{m.strength}</div>
                {m.purpose && (
                  <div className="text-xs text-[#5C6B62] mt-0.5">For: {m.purpose}</div>
                )}
                {m.directions && (
                  <div className="text-sm text-[#1C2B23] mt-2">{m.directions}</div>
                )}
              </div>
              {m.times?.length > 0 && (
                <div className="flex flex-wrap gap-1">
                  {m.times.map((t) => (
                    <span
                      key={t}
                      className="text-xs bg-[#F0EFEA] text-[#2B5339] rounded-full px-2.5 py-0.5 font-medium"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              )}
            </div>
            <div className="mt-3 grid grid-cols-2 sm:grid-cols-4 gap-2 text-xs text-[#5C6B62]">
              {m.form && <span>Form: <span className="text-[#1C2B23]">{m.form}</span></span>}
              {m.imprint_front && (
                <span>Imprint: <span className="text-[#1C2B23]">{m.imprint_front}</span></span>
              )}
              {m.manufacturer && (
                <span>Mfr: <span className="text-[#1C2B23]">{m.manufacturer}</span></span>
              )}
              {m.pharmacy && (
                <span>Pharmacy: <span className="text-[#1C2B23]">{m.pharmacy}</span></span>
              )}
            </div>
            {m.do_not_confuse && (
              <div className="mt-3 text-xs text-[#C26747]">
                <span className="font-semibold">Do not confuse with:</span> {m.do_not_confuse}
              </div>
            )}
          </div>
        ))}
      </div>

      <p className="mt-5 text-xs text-[#5C6B62] leading-relaxed">
        This caregiver copy is for organisation and communication only. It does not replace the
        pharmacy label, prescriber&apos;s instructions, or a pharmacist consultation.
      </p>
    </section>
  );
}
